export const validatorTypes = {
  notBlank: "notBlank",
  email: "email",
  phoneNumber: "phoneNumber",
}

export const validators = {
  [validatorTypes.notBlank]: (value) => !!value,
  [validatorTypes.email]: isEmailValid,
  [validatorTypes.phoneNumber]: isPhoneNumberValid,
}

export function isEmailValid(email) {
  return new RegExp(/[\w-]+@([\w-]+\.)+[\w-]+/gim).test(email)
}

export function isPhoneNumberValid(value) {
  const phoneCommonPattern = /^(?:\+|00)?[0-9]{7,17}$/
  const phoneNumber = value.replace(/\s/g, "")
  return phoneCommonPattern.test(phoneNumber) || phoneNumber === ""
}
